import { AnalyticFilter } from "@gsx/common";
import { operators } from "../../utils/utils";
import { injectable } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";

@injectable()
export class AnalyticFiltering {
    constructor(private readonly organizationListStore: OrganizationListStore) {}

    filteredItems(filter: AnalyticFilter | undefined) {
        if (!filter) {
            return [];
        }

        return (this.organizationListStore.items || []).filter((organization) => {
            const products = new Set(organization.productTags);
            const services = new Set(organization.serviceTags);
            const operatingRegimes = new Set(organization.operatingRegimeTags);
            const applicationTags = new Set(organization.applicationTags);

            return operators[filter.logicalOperator](
                {
                    list: [...filter.countries],
                    comparison: (country: string) => country === `country:${organization.country}`,
                },
                {
                    list: [...filter.products],
                    comparison: products.has.bind(products),
                },
                {
                    list: [...filter.services],
                    comparison: services.has.bind(services),
                },
                {
                    list: [...filter.operatingRegimeTags],
                    comparison: operatingRegimes.has.bind(operatingRegimes),
                },
                {
                    list: [...filter.applicationTags],
                    comparison: applicationTags.has.bind(applicationTags),
                },
            );
        });
    }
}
